export const sanitizeTextContent = (text = ''): string => (
  text
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .trim()
);
